import useSWR from 'swr'
import { guardClient } from '../_axios'
import { TagType } from 'components/atoms/selects/TagSelector'

/**
 * 会社情報の全件取得
 * [get]/company/
 */
type SalesType = {
  firstName: string
  lastName: string
}
export type CompanyType = {
  id: number
  name: string
  updateAt: string
  counter: number
  tag: TagType
  sales: SalesType[]
  focusCustomer?: boolean | null
}
export type ResponseCompany = { data: CompanyType[] }

const allCompanyFetcher = (urlTail: string) => {
  const response = guardClient.get<ResponseCompany>(urlTail).then((r) => r.data)
  return response
}
export const useAllCompany = () => {
  const path = '/company'
  const { data, mutate } = useSWR(path, allCompanyFetcher, {
    onErrorRetry: () => {
      return
    },
    suspense: true
  })

  return { data: data?.data, mutate }
}
